import React, { useContext, useEffect, useRef } from 'react';
import styles from './shMenuOverlay.module.scss';
import Link from "next/link";
import ShButton from "../../components/button/shButton";
import Emoji from "react-emoji-render";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

import BookmarkOutlineSVG from "../../public/icons/bookmarkOutline.svg";
import BrandWordmarkLight from "../../public/logo/brand-wordmark-light.svg";
import CloseSVG from "../../public/icons/close.svg";
import BookSVG from "../../public/icons/book.svg";
import AccountSVG from "../../public/icons/account.svg";
import GiftSVG from 'public/icons/gift.svg';
import LogoutSVG from "../../public/icons/logout.svg";
import DiscountSVG from "../../public/icons/discount.svg";

import { AuthContext } from "../../provider/authProvider";
import { useRouter } from "next/router";
import useAboOwn from "../../custom-hooks/useAboOwn";
import useAuthState from "../../zustand/authState";
import { usePaymentPhysicalProductState } from "../../zustand/payment/physicalProduct/paymentPhysicalProductState";

const ShMenuOverlay = ( { mode = "normal", visible = false, onClose = () => { } } ) => {

    const ref = useRef(null);
    const authContext = useContext(AuthContext);
    const router = useRouter();

    const aboOwn = useAboOwn();

    const isInternal = useAuthState(s => s.isInternal)

    const setShowProductDialog = usePaymentPhysicalProductState(s => s.setShowProductDialog);

    useEffect(
        () => {
            if (visible && ref.current) {
                disableBodyScroll(ref.current);
            } else {
                clearAllBodyScrollLocks();
            }
        },
        [ visible ]
    )

    if (!visible) {
        return null;
    }

    return (
        <div className={styles.menuOverlay} ref={ref}>

            <div className={styles.menuOverlayHeader + " d-flex align-items-center"}>
                <Link href="/" legacyBehavior>
                    <BrandWordmarkLight className={styles.menuOverlayBrandworkmark + " mr-auto"} />
                </Link>
                <CloseSVG onClick={ () => onClose() }  className={"svg-light ml-auto svg-24"} />
            </div>

            <div className={styles.menuOverlayMenu}>
                <ul>
                    <li className={router.pathname === '/kochkurse' ? styles.active : ''}>
                        <Link href={aboOwn ? "/profil/kurse" : "/kochkurse"} className="title">
                            Kochkurse
                        </Link>
                    </li>

                    {aboOwn ?
                        <>
                            <li className={router.pathname === '/rezepte' ? styles.active : ''}>
                                <Link href="/rezepte" className="title">
                                    Rezepte
                                </Link>
                            </li>
                            <li className={router.pathname === '/gutscheine' ? styles.active : ''}>
                                <Link href="/gutscheine" className="title">
                                    Gutscheine
                                </Link>
                            </li>
                        </>

                        :
                        <>
                            <li className={router.pathname === '/gutscheine' ? styles.active : ''}>
                                <Link href="/gutscheine" className="title">
                                    Gutscheine
                                </Link>
                            </li>
                            <li className={router.pathname === '/rezepte' ? styles.active : ''}>
                                <Link href="/rezepte" className="title">
                                    Rezepte
                                </Link>
                            </li>
                        </>
                    }

                    <li className={router.pathname === '/experten' ? styles.active : ''}>
                        <Link href="/experten" className="title">
                            Experten
                        </Link>
                    </li>


                    <li className={router.pathname === '/preise' ? styles.active : ''}>
                        <Link href="/preise" className="title">
                            Preise
                        </Link>
                    </li>


                    <li className={router.pathname === '/blog' ? styles.active : ''}>
                        <Link href="/blog" className="title">
                            Blog
                        </Link>
                    </li>

                    <li className={router.pathname === '/faq' ? styles.active : ''}>
                        <Link href="/faq" className="title">
                            Fragen & Antworten
                        </Link>
                    </li>


                </ul>
            </div>

            {authContext.isLoggedIn &&
            <div className={styles.menuOverlayProfile}>
                <p className="opacity-50 mb-2">Mein Profil</p>

                <ul>

                    <Link href={"/profil/kurse"} legacyBehavior>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/kurse' ? styles.active : '' )}>
                            <BookmarkOutlineSVG className={"svg-light"}/>
                            Meine Kurse
                        </li>
                    </Link>

                    <Link href={"/profil/rezepte"} legacyBehavior>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/rezepte' ? styles.active : '' )}>
                            <BookSVG className={"svg-light"} />
                            Meine Rezepte
                        </li>
                    </Link>

                    <Link href={"/profil/gutscheine"} legacyBehavior>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/gutscheine' ? styles.active : '' )}>
                            <GiftSVG className={"svg-light"}/>
                            Meine Gutscheine
                        </li>
                    </Link>

                    <Link href={"/profil/mein-account"} legacyBehavior>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/mein-account' ? styles.active : '' )}>
                            <AccountSVG className={"svg-light"}/>
                            Mein Account
                        </li>
                    </Link>

                    {/*<Link href={"/profil/rechnungen"} passHref={true} className={isInternal && "d-none"}>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/rechnungen' ? styles.active : '' )}>
                            <InvoiceSVG className={"svg-light"} />
                            Rechnungen
                        </li>
                    </Link>*/}

                    {authContext.currentUserOverview.current?.abo &&
                    <Link href={"/profil/vorteile"} legacyBehavior>
                        <li className={" d-flex align-items-center c-pointer " + (router.pathname === '/profil/vorteile' ? styles.active : '')}>
                            <DiscountSVG className={"svg-light svg-24"}/>
                            Meine Vorteile
                        </li>
                    </Link>
                    }

                    {/*<li className={"d-flex align-items-center"}>*/}
                    {/*    <StarOutlineSVG className={"svg-light" } />*/}
                    {/*    Mein 7hauben Pass*/}
                    {/*</li>*/}

                    <li className={" d-flex align-items-center c-pointer "}
                        onClick={() => authContext.logout()}>
                        <LogoutSVG className={"svg-light" } />
                        Logout
                    </li>


                </ul>
            </div>
            }



            <div className={styles.menuOverlayAction}>
                {!authContext.isLoggedIn &&
                    <ShButton variant={"outline"}
                              className={"d-block w-100 mb-3"}
                        onClick={ () => { onClose(); authContext.handleLogin(true); } }>
                        Login
                    </ShButton>
                }

                {!authContext.currentUserOverview?.current?.abo && mode !== "no-action" &&
                <ShButton variant={"primary"} className={"d-block w-100"}
                    onClick={ () => { onClose(); authContext.handlePassBuy(); } } >
                    <Emoji text={"👨‍🍳 7hauben-Pass kaufen"}/>
                </ShButton>
                }

                { mode === "geschenk" &&
                    <ShButton variant={"primary"} className={"d-block w-100"}
                              onClick={ () => { setShowProductDialog(true) } } >
                        <Emoji text={"👨‍🍳 Jetzt kaufen"}/>
                    </ShButton>
                }
            </div>

        </div>
    );
};

export default ShMenuOverlay;
